export function waitForDomReady(): Promise<void> {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    document.addEventListener("DOMContentLoaded", () => resolve(), {
      once: true,
    });
  });
}

export function waitForFontsReady(): Promise<void> {
  if ("fonts" in document) {
    return document.fonts.ready.then(() => undefined);
  }

  return Promise.resolve();
}

export function waitForCriticalImages(): Promise<void> {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>("img"));

  if (!images.length) {
    return Promise.resolve();
  }

  return Promise.all(
    images.map((img) => {
      if (img.complete) {
        return Promise.resolve();
      }

      return new Promise<void>((resolve) => {
        img.addEventListener("load", () => resolve(), { once: true });
        img.addEventListener("error", () => resolve(), { once: true });
      });
    })
  ).then(() => undefined);
}

export function nextPaint(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });
}
